import React, { forwardRef, useEffect, useState, useImperativeHandle } from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import { Step1SearchWrapper } from './Step1SearchStyled'
import {
  Container,
  FormBigTitle,
  FormLabel,
  FormLabelSecondary,
  FormRequired,
  FormWrapper,
  TableWrapper,
} from '../CommonStyled/CommonStyled'
import { Button, Col, Form, Input, Row, Select, Space, Table } from 'antd'
import {
  BREAKPOINT, RECAPTCHA_SITE_KEY,
  SELECT_ACCOUNT_LENGTH,
  SELECT_ACCOUNT_LENGTH_EXACTLY,
  SELECT_ACCOUNT_NUMBER_PRICE,
} from '../../constant'
import PaginationRow from '../PaginationRow'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { appLoadingState, breakPointState } from '../../recoil/commonState'
import validator from '../../validator'
import accountStore from '../../stores/accountStore'
import numberUtils from '../../utils/numberUtils'
import { accessTokenState } from '../../recoil/authenticationState'

const Step1Search = forwardRef((props, ref) => {
  const { nextStep } = props
  const appLoading = useRecoilValue(appLoadingState)
  const resetAccessToken = useResetRecoilState(accessTokenState)
  const recaptchaRef = React.useRef()
  const [captchaVerified, setCaptchaVerified] = useState(false)
  const [captchaToken, setCaptchaToken] = useState(false)
  const [listAccount, setListAccount] = useState(null)
  const [listAccountPaging, setListAccountPaging] = useState(null)
  const [totalCount, setTotalCount] = useState(0)
  const [accountLengthList, setAccountLengthList] = useState([])
  const [accountLengthExactlyList, setAccountLengthExactlyList] = useState([])
  const [exactLength, setExactLength] = useState(null)
  const [minMaxFee, setMinMaxFee] = useState(null)
  const breakPoint = useRecoilValue(breakPointState)

  const [paginationObj, setPaginationObj] = useState({ pageIndex: 1, pageSize: 10 })
  const [form] = Form.useForm()

  const resetForm = () => {
    form.resetFields()
    setListAccount(null)
    setListAccountPaging(null)
    setTotalCount(0)
    setAccountLengthList([])
    setAccountLengthExactlyList([])
    setExactLength(null)
    setMinMaxFee(null)
  }

  useImperativeHandle(ref, () => ({
    resetForm,
  }))

  const columns = [
    {
      title: 'STT',
      width: '10%',
      render: (text, record, index) => numberUtils.renderTableIndex(paginationObj.pageIndex, paginationObj.pageSize, index),
    },
    {
      title: 'Số tài khoản',
      width: 'auto',
      render: record => record.accountNumber,
    },
    {
      title: 'Mức giá',
      width: 'auto',
      render: record => `${record.reducedFee > 0 ? (numberUtils.thousandSeparator(record.reducedFee) + ' VNĐ') : ''}`,
    },
    {
      title: 'Lựa chọn',
      align: 'center',
      width: '15%',
      render: record =>
        <Button
          type={'primary'}
          onClick={() => handleChooseAccount(record)}>
          Chọn số này
        </Button>,
    },
  ]

  const handleCaptchaVerify = (response) => {
    if (response) {
      setCaptchaVerified(true)
      setCaptchaToken(response)
    }
  }
  const handleChooseAccount = (account) => {
    nextStep(account)
  }
  const handleSubmit = (values) => {

  }
  const getCurrentListAccount = (data, pageIndex, pageSize, exactLen, minMax) => {
    let newData = data?.length > 0 ? [...data] : []
    if (exactLen > 0) {
      newData = newData.filter(i => i.accountNumber.length === exactLen)
    }
    if (minMax) {
      const minMaxNumberArr = minMax.split('-')
      const min = Number(minMaxNumberArr[0])
      const max = Number(minMaxNumberArr[1])

      if (min === 50) {
        newData = newData.filter(i => Number(i.reducedFee) >= min * 1000000)
      } else {
        newData = newData.filter(i => Number(i.reducedFee) >= min * 1000000 && Number(i.reducedFee) < max * 1000000)
      }
    }
    setTotalCount(newData?.length)
    const indexOfLastItem = pageIndex * pageSize
    const indexOfFirstItem = indexOfLastItem - pageSize
    const currentItems = newData?.slice(indexOfFirstItem, indexOfLastItem)
    setListAccountPaging(currentItems)
  }
  const handleClick = (type) => {
    setExactLength(null)
    setMinMaxFee(null)
    setListAccountPaging(null)
    let newPaginationObj = { pageIndex: 1, pageSize: paginationObj.pageSize }
    setPaginationObj(newPaginationObj)
    form.validateFields()
      .then(values => {
        switch (type) {
          case 'search':
            setListAccount([])
            let filteredAccountLengthList = []
            let filteredAccountLengthExactlyList = []
            const accountTailLength = values.accountTailNumber?.length
            switch (accountTailLength) {
              case 3:
              case 4:
              case 5:
              case 6:
                filteredAccountLengthList = SELECT_ACCOUNT_LENGTH.filter(i => i.maxLength > 3)
                filteredAccountLengthExactlyList = SELECT_ACCOUNT_LENGTH_EXACTLY().filter(i => i.length <= 6 && i.length >= accountTailLength)
                break
              case 7:
              case 8:
              case 9:
                filteredAccountLengthList = SELECT_ACCOUNT_LENGTH.filter(i => i.maxLength > 6)
                filteredAccountLengthExactlyList = SELECT_ACCOUNT_LENGTH_EXACTLY().filter(i => i.length <= 9 && i.length >= accountTailLength)
                break
              case 10:
              case 11:
              case 12:
                filteredAccountLengthList = SELECT_ACCOUNT_LENGTH.filter(i => i.maxLength > 9)
                filteredAccountLengthExactlyList = SELECT_ACCOUNT_LENGTH_EXACTLY().filter(i => i.length <= 12 && i.length >= accountTailLength)
                break
              case 13:
              case 14:
              case 15:
                filteredAccountLengthList = SELECT_ACCOUNT_LENGTH.filter(i => i.maxLength > 12)
                filteredAccountLengthExactlyList = SELECT_ACCOUNT_LENGTH_EXACTLY().filter(i => i.length <= 15 && i.length >= accountTailLength)
                break
              default:
                break
            }
            form.setFieldsValue({
              accountNumberLength: filteredAccountLengthList[0].value,
            })
            setAccountLengthList(filteredAccountLengthList)
            setAccountLengthExactlyList(filteredAccountLengthExactlyList)
            const payloadSearch = {
              suffix: values.accountTailNumber,
              minMaxLen: filteredAccountLengthList[0].value,
              captcha: captchaToken,
            }
            accountStore.getBeautifulList(payloadSearch)
              .then(res => {
                if (res?.data?.length > 0) {
                  res?.data.sort((a, b) => a.accountNumber.length - b.accountNumber.length);
                  setListAccount(res?.data)
                  setExactLength(null)
                  form.setFieldsValue({
                    minMaxFee: null,
                  })
                  setExactLength(null)
                  getCurrentListAccount(res?.data, 1, paginationObj.pageSize, null, null)
                } else {
                  setListAccount([])
                }
              })
              .catch(() => {
                setListAccount([])
              })
              .finally(() => {
                recaptchaRef.current.reset()
                setCaptchaVerified(false)
              })
            break
          case 'filter':
            const payloadFilter = {
              suffix: values.accountTailNumber,
              minMaxLen: values.accountNumberLength,
              captcha: captchaToken,
            }
            accountStore.getBeautifulList(payloadFilter)
              .then(res => {
                if (res?.data?.length > 0) {
                  res?.data.sort((a, b) => a.accountNumber.length - b.accountNumber.length);
                  setListAccount(res?.data)
                  getCurrentListAccount(res?.data, 1, paginationObj.pageSize, null, null)
                } else {
                  setListAccount([])
                }
              })
              .catch(() => {
                setListAccount([])
              })
              .finally(() => {
                recaptchaRef.current.reset()
                setCaptchaVerified(false)
              })
            break
          default:
            break
        }
      })
      .catch(err => {
      })
  }

  const handleChangePagination = (pageIndex, pageSize) => {
    let newPaginationObj = { ...paginationObj }
    if (newPaginationObj.pageSize !== pageSize) {
      newPaginationObj.pageIndex = 1
      newPaginationObj.pageSize = pageSize
    } else {
      newPaginationObj.pageIndex = pageIndex
    }
    getCurrentListAccount(listAccount, pageIndex, pageSize, exactLength, minMaxFee)
    setPaginationObj(newPaginationObj)
    // Call api reload data
  }
  const handleChangeAccountTailNumber = () => {
    setListAccount(null)
    form.setFieldsValue({
      accountNumberLength: null,
      minMaxFee: null,
    })
    setExactLength(null)
  }
  const handleChangeAccountNumberLength = (e) => {
    if (!e) return
    form.setFieldsValue({
      minMaxFee: null,
    })
    let filteredAccountLengthExactlyList = []
    let arrSplit = e.split('-')
    let accountTailNumberLength = form.getFieldValue('accountTailNumber')?.length
    filteredAccountLengthExactlyList = SELECT_ACCOUNT_LENGTH_EXACTLY().filter(i => i.length <= arrSplit[1] && i.length >= accountTailNumberLength && i.length >= arrSplit[0])
    setAccountLengthExactlyList(filteredAccountLengthExactlyList)
    handleClick('filter')
  }
  const handleChangeAccountNumberLengthExactly = (length) => {
    if (exactLength === length) {
      setExactLength(null)
    } else {
      setExactLength(length)
    }
  }
  const handleChangeMinMaxFee = (fee) => {
    setMinMaxFee(fee)
  }

  useEffect(() => {
    let newPaginationObj = { pageIndex: 1, pageSize: paginationObj.pageSize }
    setPaginationObj(newPaginationObj)
    getCurrentListAccount(listAccount, newPaginationObj.pageIndex, newPaginationObj.pageSize, exactLength, minMaxFee)
  }, [exactLength, minMaxFee])

  useEffect(() => {
    resetAccessToken()
  }, [])


  return (
    <Step1SearchWrapper>
      <Container>
        <FormBigTitle textAlign={'center'} margin={'0 0 24px 0'}>
          Truy vấn tài khoản số đẹp
        </FormBigTitle>
        <FormWrapper>
          <Form
            form={form}
            layout={'vertical'}
            onFinish={handleSubmit}
          >
            <Row
              gutter={[
                { xs: 0, sm: 0, md: 16, lg: 16, xl: 16, xxl: 16 },
                { xs: 0, sm: 0, md: 0, lg: 0, xl: 0, xxl: 0 },
              ]}
              justify={{
                xs: 'center',
                sm: 'center',
                md: 'space-between',
                lg: 'space-between',
                xl: 'space-between',
                xxl: 'space-between',
              }}
              align={'bottom'}
            >
              <Col xs={24} sm={24} md={16} lg={20} xl={20} xxl={20}>
                <Form.Item
                  name={'accountTailNumber'}
                  rules={[{ validator: validator.validateAccountTailNumber }]}
                  label={
                    <>
                      <FormLabel>Chọn đuôi số tài khoản mong muốn</FormLabel>
                      <FormRequired> * </FormRequired>
                      <FormLabelSecondary>(Nhập dãy số từ 3 đến 15 ký tự)</FormLabelSecondary>
                    </>
                  }
                >
                  <Input
                    maxLength={15}
                    style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                    autoComplete={'off'}
                    onChange={handleChangeAccountTailNumber}
                    placeholder={'Nhập nội dung'} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={4} xl={4} xxl={4}>
                <Form.Item
                  label={''}
                >
                  <Button
                    disabled={!captchaVerified}
                    style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                    block
                    type={'primary'}
                    onClick={() => handleClick('search')}
                  >
                    Tìm kiếm
                  </Button>
                </Form.Item>
              </Col>
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={handleCaptchaVerify}
                  hl={'vi'}
                  onExpired={() => setCaptchaVerified(false)}
                />
              </Col>
            </Row>
            {
              listAccount !== null
                ? <TableWrapper margin={'16px 0 16px 0'}>
                  <Row
                    style={{ marginTop: 16 }}
                    gutter={[
                      { xs: 4, sm: 4, md: 16, lg: 16, xl: 16, xxl: 16 },
                      { xs: 4, sm: 4, md: 16, lg: 16, xl: 16, xxl: 16 },
                    ]}
                    justify={{
                      xs: 'center',
                      sm: 'center',
                      md: 'space-between',
                      lg: 'space-between',
                      xl: 'space-between',
                      xxl: 'space-between',
                    }}
                    align={'bottom'}
                  >
                    <Col xs={24} sm={8} md={8} lg={8} xl={9} xxl={9}>
                      <Form.Item
                        name={'accountNumberLength'}
                        label={'Độ dài số tài khoản'}
                      >
                        <Select
                          disabled={!captchaVerified}
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          onChange={handleChangeAccountNumberLength}
                          placeholder={'Tất cả'}>
                          {
                            accountLengthList.map((item, index) =>
                              <Select.Option key={index} value={item.value}>{item.label}</Select.Option>,
                            )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6}>
                      <Form.Item
                        label={' '}
                      >
                        <Space size={16} style={{ width: '100%', justifyContent: 'center' }}>
                          {
                            accountLengthExactlyList.map((item, index) =>
                              <Button
                                disabled={!(listAccount?.length > 0)}
                                className={
                                  `exactLengthButton ${exactLength === item.value ? '' : 'inactiveButton'} ${!(listAccount?.length > 0) ? ' disabledButton' : ''}`
                                }
                                onClick={() => handleChangeAccountNumberLengthExactly(item.value)}
                                key={index}
                                type={'primary'}
                                value={item.value}>
                                {item.label}
                              </Button>,
                            )
                          }
                        </Space>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8} lg={8} xl={9} xxl={9}>
                      <Form.Item
                        label={'Mức giá'}
                        name={'minMaxFee'}
                      >
                        <Select
                          disabled={!(listAccount?.length > 0)}
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          onChange={handleChangeMinMaxFee}
                          allowClear
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          placeholder={'Tất cả mức giá'}>
                          {
                            SELECT_ACCOUNT_NUMBER_PRICE.map((item, index) =>
                              <Select.Option key={index} value={item.value}>{item.label}</Select.Option>,
                            )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  {
                    listAccount?.length > 0
                      ? (listAccountPaging !== null)
                        ? listAccountPaging?.length > 0
                          ? <>
                            <Table
                              headerBg={'#00B74F'}
                              dataSource={listAccountPaging}
                              columns={columns}
                              scroll={{ x: 'max-content' }}
                              pagination={false}
                              rowKey={record => record.accountNumber}
                              size={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'small' : 'middle'}
                            />
                            <PaginationRow
                              onChangePagination={handleChangePagination}
                              currentListLength={listAccountPaging?.length}
                              totalCount={totalCount}
                              pageIndex={paginationObj.pageIndex}
                              pageSize={paginationObj.pageSize}
                              pageSizeOptions={[10, 50, 100, 200]}
                              showSizeChanger={true}
                            />
                          </>
                          :
                          <div style={{ textAlign: 'center', fontSize: 18 }}>
                            Không tồn tại tài khoản thỏa mãn, vui lòng chọn lại độ dài số tài khoản khác hoặc chọn lại mức
                            giá
                          </div>
                        : <></>
                      : appLoading === 0
                        ? <div style={{ textAlign: 'center', fontSize: 18, marginTop: 16 }}>
                          Không tồn tại tài khoản thỏa mãn, vui lòng chọn lại đuôi số tài khoản khác hoặc chọn lại khoảng độ
                          dài
                        </div>
                        : <></>
                  }
                </TableWrapper>
                :
                <></> // Chưa bấm tìm kiếm
            }
          </Form>
        </FormWrapper>
      </Container>
    </Step1SearchWrapper>
  )
})

Step1Search.propTypes = {
  nextStep: PropTypes.func.isRequired,
}

export default Step1Search
